import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileSignature } from '@fortawesome/free-solid-svg-icons'

import { RouteInfoType } from "../../types/types";

import DocumentsLayout from "./DocumentsLayout"
import PaymentDataListPage from "./pages/PaymentDataList"
import EditPaymentDataFormPage from "./pages/EditPaymentDataForm"
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import AccountPage from './pages/AccountPage';
import TariffPage from './pages/TariffPage';
import PaymentsHistoryPage from './pages/PaymentsHistoryPage';


const documentsRoutes = [{
    id: "documents",
    name: "documents",
    path: "/documents",
    icon: <FontAwesomeIcon icon={faFileSignature as IconProp} size={"lg"}/>,
    component: DocumentsLayout,
    header: "tariffsAndDocuments",
    nonCollapsable: true,
    routes: [
        // {
        //     path: '/documents/account',
        //     name: 'account',
        //     component: AccountPage,
        // },
        {
            path: '/documents/tariff',
            name: 'tariff',
            component: TariffPage,
        },
        {
            path: '/documents/history',
            name: 'history',
            component: PaymentsHistoryPage,
        },
        {
            path: "/documents/application-list",
            name: "form",
            component: PaymentDataListPage
        },
        {
            path: "/documents/application-form",
            name: "editForm",
            component: EditPaymentDataFormPage,
            hide: true
        }
    ]
}]

export default documentsRoutes as RouteInfoType[];
